// extracted by mini-css-extract-plugin
export default {"price":"L6-z","onSale":"M6-z","msrpLabelPrice":"N6-z","msrpLabel":"O6-z","originalPrice":"P6-z","percentOff":"Q6-z"};